var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaatoplossing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.1667 7L43.3333 7C43.8856 7 44.3333 7.44771 44.3333 8L44.3333 50.3333C44.3333 50.8856 43.8856 51.3333 43.3333 51.3333L12.6667 51.3333C12.1144 51.3333 11.6667 50.8856 11.6667 50.3333L11.6667 8C11.6667 7.44771 12.1144 7 12.6667 7L19.8333 7",
    stroke: "white",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9576 5.26666H24.3037L24.477 4.9671C25.1811 3.75 26.4955 2.93333 28 2.93333C29.5045 2.93333 30.8189 3.75 31.523 4.9671L31.6963 5.26666H32.0423H36.7333V13.4H19.2667V5.26666H23.9576Z",
    stroke: "white",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3333 23.3333L24.8889 35L18.6667 29.1667",
    stroke: "white",
    strokeWidth: 1.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaatoplossing);
export default __webpack_public_path__ + "static/media/maatoplossing.b21513c88074f7484d36834cc5b8885f.svg";
export { ForwardRef as ReactComponent };